// -- [Feature tiles grid - uniform cards; role match gets For you badge]

import type { FeatureTile, RoleKey } from '@/types/content'
import { Card, ForYouBadge } from '@/components/ui/Card'
import { Section } from '@/components/ui/Section'

interface FeatureGridProps {
  tiles: FeatureTile[]
  roleKey: RoleKey
}

const ICON_MAP: Record<string, string> = {
  scan: '📄',
  search: '🔍',
  phone: '📱',
  payment: '💳',
  approve: '✓',
}

export function FeatureGrid({ tiles, roleKey }: FeatureGridProps) {
  return (
    <Section id="features" bg="white">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 motion-enter">
        Features
      </h2>
      <p className="text-ink-muted mb-10 max-w-2xl">
        Document management built specifically for Australian car dealerships
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tiles.map((tile, i) => {
          const isActive = tile.roleTags.includes(roleKey)
          const icon = tile.iconKey ? ICON_MAP[tile.iconKey] ?? '•' : '•'
          return (
            <Card
              key={tile.id}
              emphasised={isActive}
              badge={isActive ? <ForYouBadge /> : undefined}
              enterDelay={Math.min(i, 5)}
            >
              <div className="text-2xl mb-2" aria-hidden>
                {icon}
              </div>
              <h3 className="font-semibold text-lg text-gray-900 mb-2">{tile.title}</h3>
              <p className="text-ink-muted text-sm leading-relaxed">{tile.description}</p>
            </Card>
          )
        })}
      </div>
    </Section>
  )
}
